import LogosList from './ProviderList';

export default LogosList;
